import $api from "@http";

export default class ScenariosService {
  static async getScenarios({page, size, search, sort, with_archived}) {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);
    params.append("with_archived", with_archived);

    if (search) {
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (dateRegex.test(search.trim())) {
        params.append("q[created_at_gteq]", search.trim());
      } else {
        params.append("q[search_cont]", search);
      }
    }

    if (sort?.value === "products") {
      params.append("q[s][]", `products ${sort.direction || "asc"}`);
    } else if (sort?.value === "status") {
      params.append("q[s][]", `state ${sort.direction || "asc"}`);
    } else if (sort?.value === "created_at") {
      params.append("q[s][]", `created_at ${sort.direction || "asc"}`);
    } else if (sort?.value === "due_date") {
      params.append("q[s][]", `due_date ${sort.direction || "asc"}`);
    } else if (sort?.value) {
      params.append(
        "q[s][]",
        `${sort.value.toLowerCase()} ${sort.direction || "asc"}`,
      );
    }

    return $api.get(`/api/v1/scenarios?${params.toString()}`);
  }

  static async getAllScenarios() {
    return $api.get(`/api/v1/scenarios/simulations_allowed`);
  }

  static async getProducts() {
    return $api.get(`/api/v1/products/scenarios_allowed`);
  }

  static async viewScenario({id}) {
    return $api.get(`/api/v1/scenarios/${id}`);
  }

  static async createScenario({scenario}) {
    const hasFiles =
      scenario.scenario.cover &&
      (scenario.scenario.cover instanceof File ||
        (scenario.scenario.cover.file &&
          scenario.scenario.cover.file instanceof File) ||
        (scenario.scenario.cover.path && scenario.scenario.cover.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(scenario.scenario).forEach((key) => {
        if (
          scenario.scenario[key] !== null &&
          scenario.scenario[key] !== undefined
        ) {
          if (key === "cover" && scenario.scenario.cover) {
            if (scenario.scenario.cover instanceof File) {
              formData.append("scenario[cover]", scenario.scenario.cover);
            } else if (
              scenario.scenario.cover.file &&
              scenario.scenario.cover.file instanceof File
            ) {
              formData.append("scenario[cover]", scenario.scenario.cover.file);
            } else if (scenario.scenario.cover.path) {
              formData.append(
                "scenario[cover]",
                JSON.stringify(scenario.scenario.cover),
              );
            }
          } else {
            formData.append(`scenario[${key}]`, scenario.scenario[key]);
          }
        }
      });

      return $api.post(`/api/v1/scenarios`, formData);
    } else {
      return $api.post(`/api/v1/scenarios`, scenario);
    }
  }

  static async updateScenario({id, scenario}) {
    const hasFiles =
      scenario.scenario.cover &&
      (scenario.scenario.cover instanceof File ||
        (scenario.scenario.cover.file &&
          scenario.scenario.cover.file instanceof File) ||
        (scenario.scenario.cover.path && scenario.scenario.cover.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(scenario.scenario).forEach((key) => {
        if (
          scenario.scenario[key] !== null &&
          scenario.scenario[key] !== undefined
        ) {
          if (key === "cover" && scenario.scenario.cover) {
            if (scenario.scenario.cover instanceof File) {
              formData.append("scenario[cover]", scenario.scenario.cover);
            } else if (
              scenario.scenario.cover.file &&
              scenario.scenario.cover.file instanceof File
            ) {
              formData.append("scenario[cover]", scenario.scenario.cover.file);
            } else if (scenario.scenario.cover.path) {
              formData.append(
                "scenario[cover]",
                JSON.stringify(scenario.scenario.cover),
              );
            }
          } else {
            formData.append(`scenario[${key}]`, scenario.scenario[key]);
          }
        }
      });

      return $api.patch(`/api/v1/scenarios/${id}`, formData);
    } else {
      return $api.patch(`/api/v1/scenarios/${id}`, scenario);
    }
  }

  static async archiveScenario({id}) {
    return $api.post(`/api/v1/scenarios/${id}/archive`);
  }

  static async unArchiveScenario({id}) {
    return $api.post(`/api/v1/scenarios/${id}/restore`);
  }

  static async deleteScenario({id}) {
    return $api.delete(`/api/v1/scenarios/${id}`);
  }

  static async getScenariosFeedbackTypes() {
    return $api.get(`/api/v1/scenarios/feedback_types`);
  }

  static async getCertificationTypes() {
    return $api.get(`/api/v1/certifications/types`);
  }
}
